import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";

const VoiceCard = ({ className, title, src, href }) => {
  return (
    <>
      <Link href={href}>
        <div className={clsx(className, "group flex cursor-pointer flex-col")}>
          <figure className="relative block aspect-2/1 w-full group-hover:opacity-80">
            <Image
              src={src}
              alt={title}
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </figure>
          <div className="py-3 px-4 text-center">
            <p className="text-txt-base fluid-text-[11px,16px] group-hover:text-hov">
              {title}
            </p>
          </div>
        </div>
      </Link>
    </>
  );
};

export default VoiceCard;
